module.exports = __webpack_public_path__ + "3fe4b04612159753c3177b583694ac64.jpg";